import React, { createContext, useContext, ReactNode, useCallback } from 'react';
import { useUnseenReports } from '../hooks/useUnseenReports';

interface NotificationContextType {
  hasNotification: boolean;
  totalUnseenNotifications: number;
  loading: boolean;
  error: any;
  refetch: () => Promise<void>;
  unseenReportsTotal: number;
  unseenAlertsTotal: number;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const {
    totalUnseenNotifications,
    loading,
    error,
    refetch: originalRefetch,
    unseenReportsTotal,
    unseenAlertsTotal,
  } = useUnseenReports();

  const refetch = useCallback(async () => {
    await originalRefetch();
  }, [originalRefetch]);

  const value = {
    hasNotification: totalUnseenNotifications > 0,
    totalUnseenNotifications,
    loading,
    error,
    refetch,
    unseenReportsTotal,
    unseenAlertsTotal,
  };

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
